/**
 * Calculate duration unit from days
 * Converts days to the most appropriate unit (months, weeks, or days)
 * @param {number} days - Duration in days
 * @returns {Object} - { value: number, unit: string }
 */
export const calculateDurationUnit = (days) => {
  if (!days) return { value: 3, unit: 'months' }

  // Check for months (30 days)
  if (days % 30 === 0) {
    return { value: days / 30, unit: 'months' }
  }

  // Check for weeks (7 days)
  if (days % 7 === 0) {
    return { value: days / 7, unit: 'weeks' }
  }

  // Default to days
  return { value: days, unit: 'days' }
}

/**
 * Convert frontend duration to backend days
 * @param {number} value - Duration value
 * @param {string} unit - Duration unit ('days', 'weeks', or 'months')
 * @returns {number} - Duration in days
 */
export const convertToDays = (value, unit) => {
  if (!value) return 0
  switch (unit) {
    case 'weeks':
      return value * 7
    case 'months':
      return value * 30
    default:
      return value
  }
}
